export default {
  methods: {
    strip_tags(input, allowed) {
      allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')
      let tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
      let commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi
      return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
        return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''
      })
    },
    $sanitize(dirtyHtml) {
      return this.strip_tags(dirtyHtml, [
        '<h1>',
        '<h2>',
        '<h3>',
        '<h4>',
        '<h5>',
        '<h6>',
        '<p>',
        '<br>',
        '<a>',
        '<em>',
        '<strong>',
        '<ul>',
        '<ol>',
        '<li>',
        '<i>',
        '<em>',
        '<table>',
        '<tr>',
        '<td>',
      ])
    }
  }
}
